export const environment = {
  production: false,
  applicationInsightsConnectionString: "InstrumentationKey=ba94ca48-bc6b-4438-9953-c3179ff908ba;IngestionEndpoint=https://norwayeast-0.in.applicationinsights.azure.com/;LiveEndpoint=https://norwayeast.livediagnostics.monitor.azure.com/;ApplicationId=d741c7a3-5cc1-4a9c-99d4-b3dc155014cb",
  apis: {
    employerApi: 'https://app-fagf-employer-dev.azurewebsites.net',
  },
  azureB2C: {
    clientId: 'acace731-f03a-4a57-9ba4-7c2013e2406f',
    // clientId: 'd7264c34-9585-4060-9a0f-88440b9731f4',
    authority:
      'https://fagforbundetb2cstage.b2clogin.com/fagforbundetb2cstage.onmicrosoft.com/b2c_1_employersignicatdev',
    knownAuthorities: ['fagforbundetb2cstage.b2clogin.com'],
    redirectUri: 'https://arbeidsgiver-dev.fagforbundet.dev/',
    postLogoutRedirectUri: 'https://arbeidsgiver-dev.fagforbundet.dev/auth',
    domain: 'fagforbundetb2cstage.onmicrosoft.com',
    msalScopes: [
      'https://fagforbundetb2cstage.onmicrosoft.com/deductionservices-dev/employer.readwrite',
      'https://fagforbundetb2cstage.onmicrosoft.com/deductionservices-dev/deductionlist.readwrite',
      'https://fagforbundetb2cstage.onmicrosoft.com/deductionservices-dev/user.readwrite',
    ],
  },
};
